<script setup lang="ts">
import type { PropertyOnPage } from '@@/shared/property/api-types';

defineProps<{
  property: PropertyOnPage
}>();
</script>

<template>
  <section class="pt-2xl">
    <IadTitle
      :text="$t(`property.common.description`)"
      class="mb-s"
      tag="p"
    />
    <IadTextWithOverflow>
      <p v-text="property.description" />
    </IadTextWithOverflow>
    <p class="pt-l">
      <small
        class="text-xs text-neutral-30"
        v-text="$t('property.common.reference_abbreviated', { reference: property.propertyListingRef })"
      />
    </p>
  </section>
</template>
